export interface PincodeActionTypes {
  type: PincodeActions;
  payload?: any;
}

export enum PincodeActions {
  CREATE_PINCODE = "CREATE_PINCODE",
  GET_PINCODE_LIST = "GET_PINCODE_LIST",
  SET_PINCODE_LIST = "SET_PINCODE_LIST",
  SET_PINCODE_LIST_PAGE_COUNT = "SET_PINCODE_LIST_PAGE_COUNT",
  GET_PINCODE_DATA_BY_PINCODE = "GET_PINCODE_DATA_BY_PINCODE",
  SET_PINCODE_DATA_BY_PINCODE = "SET_PINCODE_DATA_BY_PINCODE",
  EDIT_PINCODE_DATA_BY_PINCODE = "EDIT_PINCODE_DATA_BY_PINCODE",
}
